import addressForm from './addressForm.json';
import payment from './payment.json';
import advancedCustomerSearch from './advancedCustomerSearch.json';
import alerts from './alerts.json';
import settingsLanguage from './settingsLanguage.json';
import billTable from './billTable.json';
import settingsPayment from './settingsPayment.json';
import gridButtons from './gridButtons.json';
import settingsUserInterface from './settingsUserInterface.json';
import createCustomer from './createCustomer.json';
import switchUser from './switchUser.json';
import customer from './customer.json';
import offer from './offer.json';
import settingsCompany from './settingsCompany.json';
import settingsConfiguration from './settingsConfiguration.json';
import openCloseDay from './openCloseDay.json';

export const enZA = {
  addressForm,
  payment,
  advancedCustomerSearch,
  alerts,
  settingsLanguage,
  billTable,
  settingsPayment,
  gridButtons,
  settingsUserInterface,
  createCustomer,
  switchUser,
  customer,
  offer,
  settingsCompany,
  settingsConfiguration,
  openCloseDay,
};
